import { recordGA4Event } from '@components/services/analytics/ga4'
import { useUI } from '@components/ui'
import { IDeviceInfo } from '@components/ui/context'
import {
  PRODUCTS_SLUG_PREFIX,
  NEXT_GET_PRODUCT,
  NEXT_GET_BASKET_PROMOS,
  EmptyGuid,
  FacebookEvents,
  FirebaseKeys,
} from '@components/utils/constants'
import { ITEM_TYPE_ADDON, ADDED_TO_WISH } from '@components/utils/textVariables'
import {
  getCurrentPage,
  eventIdForFB,
  getCategories,
  getColor,
  getBrowserIdForFBConversion,
  getIpAddressForFBConversion,
  getDateOfBirthHash,
  getGenderHash,
  getColorAndSize,
  getRemoteConfigAsBoolean,
} from '@framework/utils/app-util'
import { getSHA256Hash } from '@framework/utils/cipher'
import axios from '@services/axiosInterceptorInstance'
import { facebookEventHandler } from 'hooks/facebook-conversion'
import { GA_EVENT } from 'hooks/ga_event.modal'
import { useGoogleAnalyticsEvent } from 'hooks/useGAEvent'
import { useMoEngageEvent } from 'hooks/useMoengageEvent'
import { useRouter } from 'next/router'
import { useCallback, useEffect, useState } from 'react'
import { buttonTitle } from '../helpers/bottenTitle.helper'
import { attributeChanged, handleWishList } from '../helpers/index.helper'
import { ProductService } from 'services/product/index.service'

interface IProps {
  deviceInfo: IDeviceInfo
  collectionName: string
  isFromCart: boolean
  productData: any
  setLoader: any
  setQuickview: any
  AF: any
  window: any
  quickViewProductSlug: string | null
  title?: string
  page?: string
}
const useProductQuickViewHook = ({
  deviceInfo,
  collectionName,
  isFromCart,
  setLoader,
  productData,
  setQuickview,
  AF,
  window,
  quickViewProductSlug,
  title,
  page,
}: IProps) => {
  const {
    openNotifyUser,
    setNotifyProduct,
    addToWishlist,
    basketId,
    setCartItems,
    user,
    openCart,
    setSidebarView,
    closeSidebar,
    cartItems,
    setAlert,
    wishListItems,
  } = useUI()
  const router = useRouter()
  const trackGoogleAnalyticsEvent = useGoogleAnalyticsEvent()
  const trackMoEngageEvent = useMoEngageEvent()
  const { asPath } = router
  const { isMobile, isIPadorTablet } = deviceInfo
  const [quickViewData, setQuickViewData] = useState<any>(undefined)
  const [reviewData, setReviewData] = useState<any>(undefined)
  const [selectedAttrData, setSelectedAttrData] = useState({
    productId: quickViewData?.recordId,
    stockCode: quickViewData?.stockCode,
    ...quickViewData,
  })
  const [updatedProduct, setUpdatedProduct] = useState<any>(null)
  const [isEngravingOpen, showEngravingModal] = useState(false)
  const [selectedSizeVariant, setSelectedSizeVariant] = useState()
  const product = updatedProduct || productData

  const [currentVariantData, setCurrentVariantData] = useState<any>({})
  let currentPage = getCurrentPage()

  useEffect(() => {
    setSelectedSizeVariant(undefined)
    const currentSizeAndColor = {
      'global.colour': product?.customAttributes?.filter(
        (attr: any) => attr?.key === 'global.colour'
      )[0]?.value,
      'clothing.size': product?.customAttributes?.filter(
        (attr: any) => attr.key === 'clothing.size'
      )[0]?.value,
    }
    setCurrentVariantData(currentSizeAndColor)
  }, [product?.customAttributes])

  // Manage price display for selected variant size.

  let deviceCheck = ''
  if (isMobile || isIPadorTablet) {
    deviceCheck = 'Mobile'
  } else {
    deviceCheck = 'Desktop'
  }
  const fetchProduct = useCallback(async () => {
    if (quickViewProductSlug) {
      const response = await ProductService.retrieveQuickViewProduct({
        slug: quickViewProductSlug?.includes('/')
          ? quickViewProductSlug?.split('/')[1]
          : quickViewProductSlug,
      })
      const getProduct = response?.data?.getProduct ?? {}
      // const response: any = await axios.post(NEXT_GET_PRODUCT, {
      //   slug: quickViewProductSlug?.startsWith('/')
      //     ? quickViewProductSlug?.substring(1)
      //     : quickViewProductSlug,
      // })

      if (getProduct?.product) {
        setUpdatedProduct({
          productId: getProduct?.product?.recordId,
          stockCode: getProduct?.product?.stockCode,
          ...getProduct?.product,
        })
        setSelectedAttrData({
          productId: getProduct?.product?.recordId,
          stockCode: getProduct?.product?.stockCode,
          ...getProduct?.product,
        })
        const attr = {
          productId: getProduct?.product?.recordId,
          stockCode: getProduct?.product?.stockCode,
          ...getProduct?.product,
        }
        setQuickViewData({
          productId: getProduct?.product?.recordId,
          stockCode: getProduct?.product?.stockCode,
          ...getProduct?.product,
        })
      }
    }
  }, [quickViewProductSlug])

  const getBasketPromo = async (basketId: string) => {
    const { data: basketPromos }: any = await axios.get(
      NEXT_GET_BASKET_PROMOS,
      {
        params: {
          basketId: basketId,
          isChannelStore: false,
        },
      }
    )
    return basketPromos
  }

  useEffect(() => {
    fetchProduct()
    // fetchIsQuickView()
  }, [fetchProduct])

  const handleNotification = () => {
    setQuickview(undefined)
    openNotifyUser(product?.recordId)
    setNotifyProduct(product)
  }

  const getlineItemSizeWithoutSlug = (product: any) =>
    product?.variantProducts
      ?.filter((vp: any) => vp?.stockCode === product?.stockCode)[0]
      ?.attributes.filter((va: any) => va.fieldCode === 'clothing.size')[0]
      ?.fieldValue

  let replacementEligibilityDays: number | null = null
  let returnEligibilityDays: number | null = null

  const returnEligeble = product?.customAttributes
    ?.find((x: any) => x.key == 'product.returnsandexchange')
    ?.value?.toLowerCase()

  const replacementEligeble = product?.customAttributes
    ?.find((x: any) => x.key == 'product.replacement')
    ?.value?.toLowerCase()

  const replacementEligibility =
    replacementEligeble === 'true' &&
    product?.customAttributes?.find(
      (x: any) => x.key == 'product.replacementeligibility'
    )?.value

  const replacementEligibilityMatch = JSON.stringify(
    replacementEligibility
  )?.match(/\d+/)

  if (replacementEligibilityMatch) {
    const number = parseInt(replacementEligibilityMatch[0], 10)
    replacementEligibilityDays = number
  }

  const returnEligibility =
    returnEligeble === 'true' &&
    product?.customAttributes?.find(
      (x: any) => x.key == 'product.returnandexchangeeligibility'
    )?.value

  const returnEligibilityMatch = JSON.stringify(returnEligibility)?.match(/\d+/)

  if (returnEligibilityMatch) {
    const number = parseInt(returnEligibilityMatch[0], 10)
    returnEligibilityDays = number
  }

  const addToCartGAEvent = async (productData: any) => {
    const eventId = eventIdForFB()
    trackGoogleAnalyticsEvent(
      GA_EVENT.ADD_TO_CART,
      {
        ecommerce: {
          items: [
            {
              item_name: productData?.name,
              item_brand: productData?.brand,
              item_category2: getCategories(productData).category2,
              item_category: getCategories(productData).category,
              item_variant: getColorAndSize(productData),
              color: getColor(productData),
              quantity: productData?.qty,
              item_id: productData?.sku,
              item_size: getlineItemSizeWithoutSlug(productData),
              price: productData?.price?.raw?.withTax,
              item_var_id: productData?.stockCode,
              item_list_name: getCategories(productData).category,
              index: 1,
            },
          ],
          cart_quantity: 1,
          total_value: productData?.price?.raw?.withTax,
          current_page: page ? page : getCurrentPage(),
          section_title: title ?? 'Quick Add',
          event_id: eventId,
          loggedin_status: !!(user?.userId && user?.userId !== EmptyGuid),
        },
      },
      window
    )

    const mobileNumber = user?.mobile || user?.telephone
    let facebookeventData = {
      data: [
        {
          event_name: FacebookEvents.ADD_TO_CART,
          event_time: Math.floor(new Date().getTime() / 1000),
          event_id: eventId,
          action_source: 'website',
          user_data: {
            em: [user?.email ? await getSHA256Hash(user?.email) : ''],
            ph: mobileNumber ? await getSHA256Hash(mobileNumber) : null,
            fn: user?.firstName ? await getSHA256Hash(user?.firstName) : null,
            ln: user?.lastName ? await getSHA256Hash(user?.lastName) : null,
            client_user_agent: window.navigator.userAgent,
            fbp: getBrowserIdForFBConversion(),
            client_ip_address: (await getIpAddressForFBConversion()) || null,
            external_id: mobileNumber
              ? await getSHA256Hash(mobileNumber)
              : null,
            db: await getDateOfBirthHash(user),
            ge: await getGenderHash(user?.gender),
            ct: null,
            zp: null,
            country: await getSHA256Hash('in'),
          },
          custom_data: {
            currency: 'INR',
            num_items: 1,
            content_name: getCurrentPage(),
            value: product?.price?.raw?.withTax,
            content_category: getCategories(productData).category,
            content_ids: [product?.stockCode],
            content_type: 'product',
            contents: [
              {
                id: product?.recordId ?? product?.productId,
                quantity: 1,
                item_price: product?.price?.raw?.withTax,
                delivery_category: 'home_delivery',
              },
            ],
          },
        },
      ],
    }

    facebookEventHandler(facebookeventData)
  }

  const buttonConfig = buttonTitle({
    productData: quickViewData,
    cartItems,
    setAlert,
    setLoader,
    product,
    selectedAttrData,
    setQuickview,
    basketId,
    user,
    replacementEligibilityDays,
    returnEligibilityDays,
    openCart,
    setCartItems,
    AF,
    window,
    isFromCart,
    collectionName,
    getBasketPromo,
    addToCartGAEvent,
    trackMoEngageEvent,
    handleNotification,
  })

  const isEngravingAvailable = !!product?.relatedProducts?.filter(
    (item: any) => item.stockCode === ITEM_TYPE_ADDON
  ).length

  const isInWishList = wishListItems
    ?.map((wi: any) => wi?.recordId)
    ?.includes(quickViewData?.recordId)

  const enableHtmlScroll = () => {
    const element: any = document.getElementsByTagName('html')[0]
    element.classList.add('overlow-y-auto-p')
  }
  const insertToLocalWishlist = (productData: any) => {
    addToWishlist(productData)
    // setIsInWishList(true)
    setAlert({ type: 'success', msg: ADDED_TO_WISH })
    // openWishlist()
  }
  // GET SELECTED PRODUCT ALL REVIEWS
  const closeModalAll = () => {
    window?.scrollTo(0, 0)
    setQuickview(undefined)
    setSidebarView('')
    closeSidebar()
  }

  const handleViewItemGAEvent = async () => {
    const currentPage = getCurrentPage()
    if (currentPage) {
      let color = ''
      if (product?.variantGroupCode) {
        color = product?.variantGroupCode.split('-')[1]
      } else if (product?.attributes?.length) {
        color = product?.attributes?.find(
          (datum: any) => datum.key === 'product.colours'
        )?.value
      }
      const eventId = eventIdForFB()
      recordGA4Event(window, GA_EVENT.VIEW_ITEM, {
        ecommerce: {
          items: [
            {
              item_name: product?.name,
              item_brand: product?.brand,
              item_category: product?.classification?.mainCategoryName,
              item_category2: product?.classification?.category,
              item_variant: color,
              quantity: 1,
              item_id: product?.sku,
              item_var_id: product?.stockCode,
              price: product?.price?.raw?.withTax,
              color,
            },
          ],
          current_page: currentPage,
          value: product?.price?.raw?.withTax,
          event_id: eventId,
          loggedin_status: !!(user?.userId && user?.userId !== EmptyGuid),
          troopod: getRemoteConfigAsBoolean(FirebaseKeys.TROOPOD_ENABLED),
        },
      })

      const mobileNumber = user?.mobile || user?.telephone
      let facebookeventData = {
        data: [
          {
            event_name: FacebookEvents.VIEW_CONTENT,
            event_time: Math.floor(new Date().getTime() / 1000),
            event_id: eventId,
            action_source: 'website',
            user_data: {
              em: [user?.email ? await getSHA256Hash(user?.email) : ''],
              ph: mobileNumber ? await getSHA256Hash(mobileNumber) : null,
              fn: user?.firstName ? await getSHA256Hash(user?.firstName) : null,
              ln: user?.lastName ? await getSHA256Hash(user?.lastName) : null,
              client_user_agent: window.navigator.userAgent,
              fbp: getBrowserIdForFBConversion(),
              client_ip_address: (await getIpAddressForFBConversion()) || null,
              external_id: mobileNumber
                ? await getSHA256Hash(mobileNumber)
                : null,
              db: await getDateOfBirthHash(user),
              ge: await getGenderHash(user?.gender),
              ct: null,
              zp: null,
              country: await getSHA256Hash('in'),
            },
            custom_data: {
              currency: 'INR',
              content_name: getCurrentPage(),
              value: product?.price?.raw?.withTax,
              content_category: productData?.classification?.mainCategoryName,
              content_ids: [product?.stockCode],
              content_type: 'product',
              contents: [
                {
                  id: product?.recordId,
                  quantity: 1,
                  item_price: product?.price?.raw?.withTax,
                  delivery_category: 'home_delivery',
                },
              ],
            },
          },
        ],
      }

      facebookEventHandler(facebookeventData)
    }
  }

  const handleGAEventExitPopupView = () => {
    const currentPage = getCurrentPage()
    if (currentPage) {
      recordGA4Event(window, GA_EVENT.EXIT_POPUP_VIEW, {
        device: deviceCheck,
        page: asPath,
        current_page: currentPage,
        section_title: collectionName,
        loggedin_status: !!(user?.userId && user?.userId !== EmptyGuid),
      })
    }
  }

  return {
    product,
    quickViewData,
    reviewData,
    selectedSizeVariant,
    selectedAttrData,
    currentVariantData,
    currentPage,
    isInWishList,
    isEngravingAvailable,
    buttonConfig,
    showEngravingModal,
    closeModalAll,
    handleWishList: (quickViewData: any) => {
      handleWishList({
        productData: quickViewData,
        setQuickview,
        user,
        asPath,
        setSidebarView,
        closeSidebar,
        currentPage,
        deviceCheck,
        product,
        AF,
        enableHtmlScroll,
        insertToLocalWishlist,
        trackMoEngageEvent,
      })
    },
    handleViewItemGAEvent,
    attributeChanged: (fieldCode: string, value: string, obj: any) => {
      attributeChanged({
        fieldCode,
        value,
        obj,
        product,
        quickViewData,
        currentVariantData,
        setSelectedAttrData: (payload: any) => {
          setSelectedAttrData(payload)
        },
        setCurrentVariantData: (payload: any) => {
          setCurrentVariantData(payload)
        },
        setSelectedSizeVariant: (payload: any) => {
          setSelectedSizeVariant(payload)
        },
        setQuickViewData,
      })
    },
    setSelectedAttrData,
    handleGAEventExitPopupView,
  }
}

export { useProductQuickViewHook }
